module.exports = __webpack_public_path__ + "img/v1.b9297b77.png";